export default __webpack_public_path__ + "static/media/android-s2-cn.b9427011.webp";